import React from 'react';

import { UploadedReceipt } from '../../../types';
import { BulkOperation } from '../apis/types';
import { useBulkOperationHeaderEdit } from '../hooks/useImportHeaderEdit';

import ImportDetailsHeaderDisplay from './ImportDetailsHeaderDisplay';
import ImportDetailsHeaderEditMode from './ImportDetailsHeaderEditMode';

interface ImportDetailsHeaderProps {
  title?: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
  onUpdate: (data: {
    title?: string;
    description?: string;
  }) => Promise<BulkOperation>;
  isUpdating: boolean;
  receipts: UploadedReceipt[];
}

const ImportDetailsHeader: React.FC<ImportDetailsHeaderProps> = ({
  title,
  description,
  createdAt,
  updatedAt,
  onUpdate,
  isUpdating,
  receipts,
}) => {
  const {
    isEditing,
    editedTitle,
    editedDescription,
    setEditedTitle,
    setEditedDescription,
    handleEdit,
    handleSave,
    handleCancel,
  } = useBulkOperationHeaderEdit({ title, description, onUpdate });

  return (
    <div className='bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6'>
      {isEditing ? (
        <ImportDetailsHeaderEditMode
          editedTitle={editedTitle}
          editedDescription={editedDescription}
          isUpdating={isUpdating}
          onTitleChange={setEditedTitle}
          onDescriptionChange={setEditedDescription}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      ) : (
        <ImportDetailsHeaderDisplay
          title={title}
          description={description}
          createdAt={createdAt}
          updatedAt={updatedAt}
          receipts={receipts}
          onEdit={handleEdit}
        />
      )}
    </div>
  );
};

export default ImportDetailsHeader;
